import { TextField } from '@mui/material';
import React, { useEffect, useState } from 'react';

import { rutChanger, validaRut } from '../../functions/utils';

const RutSearcher = (props: any) => {
  const { setBusiness, setSearched } = props;
  const [identifier, setIdentifier] = useState('');

  const [rutValidated, setRutValidated] = useState(false);

  const handleChangeIdentifier = (e: any) => {
    setSearched(false);
    setRutValidated(false);
    rutChanger(e.target.value, setIdentifier);

    if (validaRut(e.target.value)) {
      setBusiness({ identifier: e.target.value });
      setRutValidated(true);
      setSearched(true);
    } else {
      setBusiness(null);
      setRutValidated(false);
    }
  };

  const hasError = identifier.length > 0 && !validaRut(identifier);

  useEffect(() => {
    if (identifier === '') {
      setSearched(false);
      setBusiness(null);
      setRutValidated(false);
    }
  }, []);

  return (
    <div>
      <div style={{ padding: '10px 0px' }}>
        <TextField
          label="RUT"
          placeholder="Sin puntos con guión. Ej: 12345678-K"
          value={identifier}
          color={rutValidated ? 'success' : 'error'}
          fullWidth
          error={hasError}
          helperText={hasError ? 'Ingrese un RUT válido' : ''}
          onChange={(e) => handleChangeIdentifier(e)}
        />
      </div>
    </div>
  );
};

export default RutSearcher;
